import { giphyBlack } from '@giphy/js-brand'
import { SearchContext } from '@giphy/react-components'
import React, { useContext } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { MARGIN } from '../../constants'
import { AppContext, SearchMode } from '../../context'
import { clipsButton, emojiButton, gifButton, stickerButton, textButton } from '../../img/images'
import ActiveTabItem from './dot'

export const footerHeight = 45

const fadeIn = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`

const Container = styled.div<{ showGradient: boolean }>`
    margin: ${MARGIN}px 30px;
    margin-bottom: 0;
    background: ${giphyBlack};
    display: flex;
    align-content: center;
    justify-content: space-between;
    font-size: 18px;
    height: ${footerHeight}px;
    bottom: 0px;
    position: relative;
    &:after {
        background: linear-gradient(360deg, ${giphyBlack}, rgba(0, 0, 0, 0));
        content: '';
        position: absolute;
        left: -100px;
        top: -50px;
        right: -100px;
        bottom: ${footerHeight + MARGIN}px;
        pointer-events: none;
        ${(props) =>
            !props.showGradient &&
            css`
                display: none;
            `}
    }
    opacity: 0;
    animation: ${fadeIn} 1s forwards 200ms;
`

const Item = styled.div<{ offset?: number }>`
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 ${MARGIN}px;
    flex-direction: column;
    img {
        transform: translateY(${(props) => props.offset || 0}px);
    }
`

const DotIcon = styled.div<{ $showDot: boolean }>`
    height: 25px;
    position: relative;

    &::after {
        background-color: #ff6666;
        border-radius: 50%;
        border: 2px solid #121212;
        box-sizing: border-box;
        content: '';
        display: ${({ $showDot }) => ($showDot ? 'block' : 'none')};
        height: 14px;
        position: absolute;
        right: -4px;
        top: -5px;
        width: 14px;
    }
`

type NavItemProps = { onClick: (mode: SearchMode) => void }
const Gifs = ({ onClick }: NavItemProps) => {
    const { searchMode } = useContext(AppContext)
    return (
        <Item onClick={() => onClick('gifs')}>
            <img src={gifButton} />
            {searchMode === 'gifs' && <ActiveTabItem colors={['#9345FA', '#FF6666']} />}
        </Item>
    )
}

const Emoji = ({ onClick }: NavItemProps) => {
    const { searchMode, seenMessage, seenOnboard } = useContext(AppContext)
    const showDot = !seenMessage('emojiVariations') && seenOnboard
    return (
        <Item onClick={() => onClick('emoji')}>
            <DotIcon $showDot={showDot}>
                <img src={emojiButton} />
            </DotIcon>
            {searchMode === 'emoji' && <ActiveTabItem colors={['#FFF35C', '#FF6666']} />}
        </Item>
    )
}

const Stickers = ({ onClick }: NavItemProps) => {
    const { searchMode } = useContext(AppContext)
    return (
        <Item onClick={() => onClick('stickers')}>
            <img src={stickerButton} />
            {searchMode === 'stickers' && <ActiveTabItem colors={['#00B8BD', '#00FF99']} />}
        </Item>
    )
}

const Clips = ({ onClick }: NavItemProps) => {
    const { searchMode } = useContext(AppContext)
    return (
        <Item onClick={() => onClick('videos')}>
            <img src={clipsButton} />
            {searchMode === 'videos' && <ActiveTabItem colors={['#9933FF', '#6157FF']} />}
        </Item>
    )
}

const Text = ({ onClick }: NavItemProps) => {
    const { searchMode, seenMessage, seenOnboard } = useContext(AppContext)
    const showDot = !seenMessage('giphyText') && seenOnboard
    return (
        <Item onClick={() => onClick('text')}>
            <DotIcon $showDot={showDot}>
                <img src={textButton} />
            </DotIcon>
            {searchMode === 'text' && <ActiveTabItem colors={['#5C6FFF', '#18B5FF']} />}
        </Item>
    )
}

const Nav = () => {
    const { setSearchMode, setDisplayGif, displayGif, config } = useContext(AppContext)
    const { setSearch, setActiveChannel, activeChannel } = useContext(SearchContext)
    const onClick = (mode: SearchMode) => {
        if (mode === 'emoji' || mode === 'text' || mode === 'videos') {
            if (mode === 'emoji') setSearch('')
            if (activeChannel) setActiveChannel(undefined)
        }
        setDisplayGif(undefined)
        setSearchMode(mode)
    }
    return (
        <Container showGradient={!displayGif} className="no-animation-in-percy">
            <Gifs onClick={onClick} />
            <Stickers onClick={onClick} />
            {config.isBrowserExtension && <Clips onClick={onClick} />}
            <Emoji onClick={onClick} />
            <Text onClick={onClick} />
        </Container>
    )
}

export default Nav
